export const fetchMethods = {
  POST: 'POST',
  GET: 'GET',
  PUT: 'PUT',
}

export const itemsPerPage = '12'

// Hardcoded because that is the exact return from the FetchCustomToken API
export const invalidCodeMessage = 'Invalid code'
